import React, { Component } from 'react';
import { Icon, Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@material-ui/core';
import moment from 'moment';
import _ from 'lodash';

const styles = theme => ({
    layoutRoot: {},
});

class StudentGradebook extends Component {

    getCourseTable = (display, courses, student_id) => {
        if (!display) { return null }

        const currentCourseRows = courses.map(c => {
            return (
                <TableRow key={c.company_calendar_course_id}>
                    <TableCell>{c.CourseName}</TableCell>
                    <TableCell>
                        <IconButton
                            onClick={() => this.props.history.push(`/gradebook/student/event_list/${c.company_calendar_course_id}/${student_id}`)}
                        >
                            <Icon>book</Icon>
                        </IconButton>
                    </TableCell>
                </TableRow>
            )
        })

        const tableBase =
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Course</TableCell>
                        <TableCell>To Gradebook</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentCourseRows}
                </TableBody>
            </Table>

        return tableBase
    }

    render() {
        const { progress, student } = this.props;
        const currentCourses = progress.filter(p => p.finished === 0)
        const finishedCourses = progress.filter(p => p.finished === 1)

        return (
            <div>
                <div style={{ paddingBottom: '20px' }}>
                    <Typography variant="h5"> {currentCourses.length > 0 ? 'Current Courses' : 'No Current Courses'} </Typography>
                    {this.getCourseTable(currentCourses.length > 0, currentCourses, student.student_id)}
                </div>
                <div>
                    <Typography variant="h5"> {finishedCourses.length > 0 ? 'Finished Courses' : 'No Finished Courses'} </Typography>
                    {this.getCourseTable(finishedCourses.length > 0, finishedCourses, student.student_id)}
                </div>
            </div>
        );
    }

}

export default (StudentGradebook);


// WEBPACK FOOTER //
// src/main/content/student/StudentGradebook.js